var _ellipse, _ellipse2, _ellipse3, _circle, _path, _path2, _path3, _line, _line2, _line3, _line4, _circle2, _circle3, _path4, _circle4, _circle5, _path5, _line5, _line6, _line7, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "svg-stroke-thin",
    cx: 186.37,
    cy: 234.95,
    rx: 36.85,
    ry: 14.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "svg-stroke-thin",
    cx: 186.36,
    cy: 234.95,
    rx: 14.08,
    ry: 36.85,
    transform: "translate(-92.51 124.66) rotate(-30)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "svg-stroke-thin",
    cx: 186.36,
    cy: 234.91,
    rx: 36.85,
    ry: 14.08,
    transform: "translate(-110.26 278.84) rotate(-60)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "svg-stroke-thin",
    cx: 186.37,
    cy: 234.95,
    r: 4.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M337.61,273.76H326.56a.43.43,0,0,0-.38.23l-7.26,12.49L311.58,274a.43.43,0,0,0-.38-.23h-11l18.7,32.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M337.61,273.76l-18.69,32.32-18.7-32.32H288a.43.43,0,0,0-.38.68l31,53.44a.49.49,0,0,0,.83,0l31-53.44a.48.48,0,0,0-.38-.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M127.82,342.79v31.32a4.17,4.17,0,0,1-2.07,3.56l-27.1,15.66a4.09,4.09,0,0,1-4.14,0L67.33,377.67a4.17,4.17,0,0,1-2.07-3.56V342.79a4.17,4.17,0,0,1,2.07-3.56l27.1-15.66a4.09,4.09,0,0,1,4.14,0l27.09,15.66A3.92,3.92,0,0,1,127.82,342.79Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 65.26,
    y1: 340.39,
    x2: 96.58,
    y2: 394.58
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 65.26,
    y1: 376.51,
    x2: 75.7,
    y2: 358.45
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 127.82,
    y1: 376.51,
    x2: 96.58,
    y2: 322.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 127.82,
    y1: 340.39,
    x2: 117.38,
    y2: 358.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "svg-stroke-thin",
    cx: 246.72,
    cy: 403.71,
    r: 2.91
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "svg-stroke-thin",
    cx: 246.72,
    cy: 403.71,
    r: 2.91
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M255,395.8c-9.51,0-15.27,3.33-15.27,7.49v6.87h15.34v3.68H230.76c-4.16,0-7.49,5.62-7.49,14.36,0,8.54,3.33,14.92,7.49,14.92h6.87v-6.73a9.61,9.61,0,0,1,9.37-9.64h9.71v-.07h6.39a7.11,7.11,0,0,0,7.08-7.08V403.29C270.24,399.2,264.42,395.8,255,395.8Zm-8.26,10.82a2.91,2.91,0,1,1,2.92-2.91A3,3,0,0,1,246.72,406.62Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "svg-stroke-thin",
    cx: 265.04,
    cy: 453.46,
    r: 2.91
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "svg-stroke-thin",
    cx: 265.04,
    cy: 453.46,
    r: 2.91
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M256.78,461.37c9.51,0,15.27-3.33,15.27-7.49V447H256.71v-3.68H281c4.16,0,7.49-5.62,7.49-14.36,0-8.54-3.33-14.92-7.49-14.92h-6.87v6.66a9.62,9.62,0,0,1-9.37,9.65h-9.71v.06h-6.39a7.11,7.11,0,0,0-7.07,7.08v16.31C241.52,458,247.35,461.37,256.78,461.37ZM265,450.55a2.92,2.92,0,1,1-2.91,2.91A2.93,2.93,0,0,1,265,450.55Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 119.57,
    y1: 77.9,
    x2: 119.57,
    y2: 160.85
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 155.13,
    y1: 98.64,
    x2: 83.93,
    y2: 140.12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "svg-stroke-thin",
    x1: 83.93,
    y1: 98.64,
    x2: 155.13,
    y2: 140.12
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "svg-stroke-thin",
    points: "133.46 127.5 119.57 135.63 105.67 127.5 105.67 111.25 119.57 103.2 133.46 111.25 133.46 127.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M151.92,142l-29,16.89a6.51,6.51,0,0,1-6.63,0L87.21,142a6.63,6.63,0,0,1-3.28-5.7V102.41a6.56,6.56,0,0,1,3.28-5.7l29-16.89a6.49,6.49,0,0,1,6.62,0l29,16.89a6.61,6.61,0,0,1,3.28,5.7v33.93A6.63,6.63,0,0,1,151.92,142Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M436.18,177.46c-1.06-7.34-6.54-12.68-11.8-17.62-8.87-8.33-13.25-18.59-12.62-30.6-17.68,17.67-25.76,32.18-27.3,50-1.25,14.31,5.91,30.17,25.8,30.17C428.94,209.39,439,196.89,436.18,177.46Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M399.62,142.81S384.76,197.35,434.1,196"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M384.46,179.22c4.45,10.54,22.19,25.19,52.18,4.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M412.64,140.07s-32.72,36.63-9.11,68.64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M444.83,319.59c-6.81-10.51-20.31-13.67-30.13-6.94l-17.19,11.79a21.23,21.23,0,0,0-8.87,14.22A23.57,23.57,0,0,0,390.7,353a21.29,21.29,0,0,0-2.94,7.95,24.07,24.07,0,0,0,3.57,17.11c6.87,10.57,20.37,13.67,30.12,7l17.19-11.79a21.16,21.16,0,0,0,8.88-14.21,23.57,23.57,0,0,0-2.07-14.35,21,21,0,0,0,2.94-8,23.62,23.62,0,0,0-3.56-17.18"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M413,379.08a13.15,13.15,0,0,1-14.62-5.86,14.5,14.5,0,0,1-2.19-10.31c.13-.61.25-1.15.38-1.75l.31-1.08.87.67a22.35,22.35,0,0,0,6.75,3.64l.63.2-.06.68a4.72,4.72,0,0,0,.68,2.76,4,4,0,0,0,4.44,1.82,5.4,5.4,0,0,0,1.06-.47l17.13-11.79A3.84,3.84,0,0,0,430,355a4.5,4.5,0,0,0-.63-3.1,4,4,0,0,0-4.44-1.75,5.09,5.09,0,0,0-1.06.47l-6.56,4.51a11.28,11.28,0,0,1-3.5,1.62,13.15,13.15,0,0,1-14.63-5.86,14.42,14.42,0,0,1-2.12-10.31,12.8,12.8,0,0,1,5.37-8.55l17.13-11.79a13.33,13.33,0,0,1,3.5-1.69,13.15,13.15,0,0,1,14.62,5.86,14.5,14.5,0,0,1,2.19,10.31,15.45,15.45,0,0,1-.44,1.75l-.25,1.08-.87-.67a22.11,22.11,0,0,0-6.75-3.64l-.63-.2.07-.68a4.8,4.8,0,0,0-.69-2.76,4,4,0,0,0-4.44-1.75,5.09,5.09,0,0,0-1.06.47L407.7,340.14a3.67,3.67,0,0,0-1.62,2.56,4.45,4.45,0,0,0,.62,3.1,4,4,0,0,0,4.44,1.75,5.09,5.09,0,0,0,1.06-.47l6.57-4.51a12.59,12.59,0,0,1,18.12,4.17,14.5,14.5,0,0,1,2.19,10.31,12.77,12.77,0,0,1-5.38,8.55l-17.12,11.79a12.67,12.67,0,0,1-3.57,1.69"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M335.76,104.69h-5.41L310.08,59.58H291.67a1.81,1.81,0,0,0-1.81,1.81v10a1.81,1.81,0,0,0,1.81,1.81H301l20.3,45.1h14.49a1.81,1.81,0,0,0,1.81-1.81v-10A1.81,1.81,0,0,0,335.76,104.69Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-thin",
    d: "M283.47,118.34h11.07a1.8,1.8,0,0,0,1.65-1.06l7.56-16.58a1.81,1.81,0,0,0,0-1.51l-5.63-12.34a1.81,1.81,0,0,0-3.3,0l-13,28.94A1.81,1.81,0,0,0,283.47,118.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.a6886c78df0c507a942165d3e685dfc1.svg";
export { ForwardRef as ReactComponent };